import { render } from "./EditCategoryModalComponent.vue?vue&type=template&id=64221fae&scoped=true"
import script from "./EditCategoryModalComponent.vue?vue&type=script&lang=js"
export * from "./EditCategoryModalComponent.vue?vue&type=script&lang=js"

import "./EditCategoryModalComponent.vue?vue&type=style&index=0&id=64221fae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64221fae"]])

export default __exports__